import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import './styles.css'

class ControlActividadModal extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            timer: this.props.second
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.second !== this.props.second){
            this.setState({
                timer: nextProps.second
            })
        }
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='sm'
                fullWidth={true}
                className='ControlActividadModal'
            >
                <DialogContent className='contenido'>
                    <DialogContentText id="alert-dialog-description">
                        <div style={{marginBottom: '20px'}}>Querés continuar con el pedido?</div>
                        <div>Si no respondes en {this.state.timer}</div>
                        <div style={{marginBottom: '40px'}}>segundos se cancelará el pedido.</div>
                    </DialogContentText>
                </DialogContent>

                <DialogActions className='botones'>
                        <Button onClick={() => {this.props.handleOnClose(0)}} className="btnPrincipal btn">
                            TODAVÍA ESTOY PIDIENDO
                        </Button>

                        <Button onClick={() => {this.props.handleOnClose(1)}} className="btnPrincipal btn">
                            YA TERMINÉ, CONFIRMAR!
                        </Button>

                        <Button onClick={() => {this.props.handleOnCancelar()}} className="btnCancelar">
                            CANCELAR PEDIDO AHORA
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

ControlActividadModal.propTypes = {
    handleOnClose: PropTypes.func,
    handleOnCancelar:PropTypes.func,
    seconds: PropTypes.object,
    open: PropTypes.object,
}

ControlActividadModal.defaultProps = {
    handleOnClose: f => f
}

export default ControlActividadModal